export default "__VITE_ASSET__DMkIpcx___"